import React from 'react';
import {
  Box,
  List,
  ListItemButton,
  ListItemText,
  Paper,
  Typography,
} from '@mui/material';

export default function ModuleSidebar({ modules = [], selectedModule, onSelectModule }) {
  return (
    <Paper
      variant="outlined"
      sx={{
        p: 1,
        position: { md: 'sticky' },
        top: { md: 16 },
        maxHeight: { md: 'calc(100vh - 120px)' },
        overflow: 'auto',
      }}
    >
      <Typography variant="overline" sx={{ px: 1, color: '#64748b' }}>
        Modules
      </Typography>
      <List dense disablePadding>
        {modules.map((mod) => (
          <ListItemButton
            key={mod.module}
            selected={selectedModule === mod.module}
            onClick={() => onSelectModule(mod.module)}
            sx={{ borderRadius: 1, mb: 0.5 }}
          >
            <ListItemText
              primary={mod.label || mod.module}
              secondary={`${mod.documents?.length ?? 0} doc(s)`}
              primaryTypographyProps={{ fontSize: 14, fontWeight: selectedModule === mod.module ? 600 : 400 }}
            />
          </ListItemButton>
        ))}
      </List>
      {!modules.length && (
        <Box sx={{ p: 2 }}>
          <Typography variant="body2" color="text.secondary">
            No guide modules loaded.
          </Typography>
        </Box>
      )}
    </Paper>
  );
}
